// extracted by mini-css-extract-plugin
module.exports = {"vanlife-menu-tree":"MenuTree_vanlife-menu-tree__D89lP"};